import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import 'Css/table.css'

function TabRedditivita(props: any) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.TITLE_FREQUENZA_1}{" "}
                    {AppConstants.TITLE_FREQUENZA_5}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaRd11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaRd11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.anomaliaRd11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.anomaliaRd11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.anomaliaRd11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.TITLE_FREQUENZA_1}{" "}
                    {AppConstants.TITLE_FREQUENZA_3}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaRd15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaRd15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.anomaliaRd15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.anomaliaRd15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.anomaliaRd15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
        </React.Fragment>
    )
}
export default TabRedditivita
